<template>
  <div class="tab-bar-layout">
    <section class="tab-bar-layout-content">
      <slot />
    </section>

    <md-tab-bar
      v-model="current"
      class="app-tab-bar"
      :items="items"
      :has-ink="false"
      @change="pushRouter"
    >
      <template slot="item" slot-scope="{ item }">
        <div class="tab-item">
          <div class="icon">
            <svg-icon :name="item.name === current ? item.iconActive : item.icon" />
          </div>
          <div class="text">
            <span v-text="item.label" />
          </div>
        </div>
      </template>
    </md-tab-bar>
  </div>
</template>

<script>
import { TabBar, Icon } from 'mand-mobile'

export default {
  name: 'Layout',

  components: {
    [TabBar.name]: TabBar,
    [Icon.name]: Icon
  },

  data () {
    return {
      current: 'Home',
      items: [
        { name: 'Home', label: this.$t('home'), icon: 'Home', iconActive: 'Home-YES' },
        // { name: 'Card', label: this.$t('back_card'), icon: 'Card', iconActive: 'Card-YES' },
        { name: 'Me', label: this.$t('me_tit'), icon: 'Me', iconActive: 'Me-YES' }
      ]
    }
  },
  watch: {
    '$route.name' (value) {
      this.current = value
    }
  },
  methods: {
    pushRouter (item, index, prevIndex) {
      // 当前页面不重复跳转
      if (item.name === this.$route.name) return

      this.$router.push({
        name: item.name
      })
    }
  }
}
</script>

<style lang="scss">
.tab-bar-layout {
  display: flex;
  flex: 1 auto;
  flex-direction: column;
  height: 100%;
}

.tab-bar-layout-content {
  min-height: calc(100% - 100px);
  overflow-y: auto;
}

.app-tab-bar {
  min-height: 88px;
  background-color: #fff;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
  transform: translate3d(0, 0, 0); // HACK 分层优化
  overflow: hidden;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding-bottom: 10px;
}

.icon {
  .svg-icon {
    width: 56px !important;
    height: 56px !important;
  }
}

.text {
  font-size: 20px;
  color: #333;
}

// 激活状态下的样式
.active {
  .text {
    color: #000;
  }
}
</style>
